export default "__VITE_ASSET__B5W510jQ__"